import { Helmet } from 'react-helmet-async';

// Main business structured data - used site-wide
export const BusinessStructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Locksmith",
    "name": "Royal Security",
    "alternateName": "Royal Security Doors and Windows",
    "description": "Specialist locksmith, door, window, and glazing engineer serving East London, North-East London, and Essex. Expert repairs for multipoint locking systems, tilt and turn windows, aluminium and uPVC doors, and glazing solutions.",
    "url": "https://royalsecurity.info",
    "telephone": "+447710613783",
    "email": "Joe@RoyalSecurity.info",
    "logo": "https://customer-assets.emergentagent.com/job_3f988ab0-bb5d-4df6-9244-d8d19e4e0941/artifacts/5s14fwfn_3E4FBAAA-8469-4ED6-B29F-A0F7D8CD94DA.png",
    "image": "https://customer-assets.emergentagent.com/job_3f988ab0-bb5d-4df6-9244-d8d19e4e0941/artifacts/5s14fwfn_3E4FBAAA-8469-4ED6-B29F-A0F7D8CD94DA.png",
    "priceRange": "££",
    "areaServed": [
      {
        "@type": "City",
        "name": "Romford",
        "containedInPlace": {
          "@type": "AdministrativeArea",
          "name": "Greater London"
        }
      },
      {
        "@type": "AdministrativeArea",
        "name": "Havering"
      },
      {
        "@type": "City",
        "name": "Hornchurch"
      },
      {
        "@type": "City",
        "name": "Upminster"
      },
      {
        "@type": "City",
        "name": "Dagenham"
      },
      {
        "@type": "City",
        "name": "Barking"
      },
      {
        "@type": "City",
        "name": "Ilford"
      },
      {
        "@type": "City",
        "name": "Chelmsford",
        "containedInPlace": {
          "@type": "AdministrativeArea",
          "name": "Essex"
        }
      },
      {
        "@type": "City",
        "name": "Stratford",
        "containedInPlace": {
          "@type": "AdministrativeArea",
          "name": "Greater London"
        }
      },
      {
        "@type": "Place",
        "name": "Canary Wharf",
        "containedInPlace": {
          "@type": "AdministrativeArea",
          "name": "Greater London"
        }
      }
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "14:00"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Door, Window, and Lock Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Multipoint Lock Repairs",
            "description": "Expert diagnosis and repair of multipoint locking systems for uPVC and composite doors"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Tilt and Turn Window Repairs",
            "description": "Specialist repairs for tilt and turn window mechanisms and hardware"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Door and Window Alignment",
            "description": "Professional realignment services for doors and windows that stick, drag or fail to close properly"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Glazing Repairs and Upgrades",
            "description": "Replacement of misted, cracked or failed sealed units with options for thermal and acoustic glass upgrades"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "uPVC and Aluminium Door Repairs",
            "description": "Comprehensive repair services for uPVC and aluminium entrance doors, patio doors, and bi-fold systems"
          }
        }
      ]
    },
    "knowsAbout": [
      "Multipoint locking systems",
      "Tilt and turn windows",
      "Tilt and slide doors",
      "uPVC door repairs",
      "Aluminium door repairs",
      "Double glazing repairs",
      "Lock mechanism repairs",
      "Door alignment",
      "Window hardware replacement"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

// Page-specific structured data for local service pages
export const LocalServiceStructuredData = ({ 
  areaName, 
  areaType = "City",
  description,
  slug 
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": `Door, Window & Lock Services in ${areaName}`,
    "description": description,
    "url": `https://royalsecurity.info/${slug}`,
    "provider": {
      "@type": "Locksmith",
      "name": "Royal Security",
      "telephone": "+447710613783",
      "email": "Joe@RoyalSecurity.info"
    },
    "areaServed": {
      "@type": areaType,
      "name": areaName
    },
    "serviceType": [
      "Locksmith Services",
      "Door Repairs",
      "Window Repairs",
      "Glazing Services",
      "Multipoint Lock Repairs"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};
